import type { AdminAccountPaymentSummaryResponseAppGroupsItem } from './adminAccountPaymentSummaryResponseAppGroupsItem';

export interface AdminAccountPaymentSummaryResponse {
  appGroups: AdminAccountPaymentSummaryResponseAppGroupsItem[];
  userId: string;
}
